<script setup>
// @ts-check

import { reformatDateString } from '@/helpers/dates'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  payslipInput: {
    /** @type {import('vue').PropType<PayslipInput>} */
    type: Object,
    required: true
  },
  secured: {
    type: Boolean
  }
})

const { t } = useI18n()

const recipientSsn = computed(() => {
  const ssn = props.payslipInput.recipient_ssn

  if (!props.secured) {
    return ssn
  }

  return `${ssn.substring(0, 7)}****`
})
</script>

<template>
  <div class="flex flex-col gap-y-4 sm:flex-row">
    <div class="flex-1">
      <p>{{ t('salary.recipient_name') }}</p>
      <p>
        {{ payslipInput.recipient_first_name }}
        {{ payslipInput.recipient_last_name }}
      </p>
    </div>
    <div class="flex-1">
      <p>{{ t('salary.labels.recipient_ssn') }}</p>
      <p>{{ recipientSsn }}</p>
    </div>
  </div>

  <div class="flex flex-col gap-y-4 sm:flex-row">
    <div class="flex-1">
      <p>{{ t('salary.labels.recipient_iban') }}</p>
      <p>{{ payslipInput.recipient_iban }}</p>
    </div>
    <div class="flex-1">
      <p>{{ t('salary.labels.payment_date') }}</p>
      <p>{{ reformatDateString(payslipInput.payment_date) }}</p>
    </div>
  </div>
</template>
